module.exports = __webpack_public_path__ + "media/images/lb/504-a581f74ad25f1f7897720b02c5b56099.svg";